import {ErrorCode} from 'presentation/hooks/useGeolocation/types';
import {GeolocationErrorKind} from './types';

const geolocationErrorConfig: Partial<
	Record<number, {kind: GeolocationErrorKind; openInstructions?: boolean}>
> = {
	[ErrorCode.PERMISSION_DENIED]: {
		kind: 'permissionDenied',
		openInstructions: true,
	},
	[ErrorCode.TIMEOUT]: {
		kind: 'timeout',
	},
	[ErrorCode.POSITION_UNAVAILABLE]: {
		kind: 'positionUnavailable',
	},
	[ErrorCode.NOT_SUPPORTED]: {
		kind: 'notSupported',
	},
};

export {geolocationErrorConfig};
